// Minimal product image gallery — ported from ProductGallery.jsx's activeIndex state.
(function () {
  function setup(root) {
    var mainImg = root.querySelector('[data-tap-gallery-main]');
    var thumbs = root.querySelectorAll('[data-tap-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); t.removeAttribute('aria-current'); });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
        if (mainImg) {
          mainImg.src = thumb.getAttribute('data-full-src');
          mainImg.alt = thumb.getAttribute('data-full-alt') || '';
        }
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('[data-tap-gallery]').forEach(setup);
  });
})();
